import React from 'react';

import Accordion from 'components/accordion';
import { CheckPointsList } from 'components/check-points-list';

import { useStyles } from './styles';

interface MedicationAccordionProps {
    title: string;
    listedItems: any[];
}

export const MedicationAccordion = ({ title, listedItems }: MedicationAccordionProps) => {

    const {
        accordionWrapper,
        blockTitle,
        subtitleClass,
        descriptionClass,
        head,
        chevron,
        openChevron,
        headTitle,
        itemWrapperClass,
        checkPointsListWrapper,
        checkPointText
    } = useStyles();

    const TitleComponent = ({ title, isOpen }: any) => {
        return <div className={head}>
            <h2 className={headTitle}>
                {title}
            </h2>
            <span className={`${chevron} ${isOpen && openChevron}`}></span>
        </div>
    };

    const DetailComponent = ({ subtitle, items, description }: any) => {
        return <div>
            {subtitle && <h2 className={subtitleClass}>{subtitle}</h2>}

            {items && <CheckPointsList items={items} listItemClassName={checkPointsListWrapper} listItemTextClassName={checkPointText} />}

            {description && <p className={descriptionClass}>{description}</p>}
        </div>
    };

    return (
        <div className={accordionWrapper}>
            <h1 className={blockTitle}>
                {title}
            </h1>

            <Accordion
                items={listedItems}
                TitleComponent={TitleComponent}
                DetailComponent={DetailComponent}
                itemWrapperClass={itemWrapperClass}
            />
        </div>
    );
};
